import { nextFrame } from "../../../library-js/animation/nextFrame";
import { UserAgentDeviceTypes } from "../../../library-js/dom/UserAgentDeviceType";
import { RenderQuality } from "../../../library-templates/render--quality/RenderQuality";

export class AnimatableKey
{
  attribute:string;
  from:string; 
  to:string;
}

export class AnimatableElement
{
  element:HTMLElement;
  keys:AnimatableKey[];
  transition?:string

  static startAll( ae:AnimatableElement[] )
  {
    ae.forEach( a => AnimatableElement.start( a ) ); 
  }

  static start( ae:AnimatableElement )
  {
    let cachedTransition = ae.element.style.transition;
    ae.element.style.transition = "none";

    for ( let k of ae.keys )
    {
      ae.element.style[ k.attribute as any ] = k.from;
    }    

    ae.transition = cachedTransition;
  }

  static endAll( ae:AnimatableElement[] )
  {
    ae.forEach( a => AnimatableElement.end( a ) ); 
  }


  static end( ae:AnimatableElement )
  {    
    for ( let k of ae.keys )
    {
      ae.element.style[ k.attribute as any ] = k.to;
    }   
    
    ae.element.style.transition = ae.transition;
  }

  static async animate( ae:AnimatableElement[] )
  {
    if ( UserAgentDeviceTypes.current != UserAgentDeviceTypes.PC || RenderQuality.isHighQuality )
    {
      AnimatableElement.startAll( ae );

      await nextFrame(); await nextFrame(); await nextFrame();
  
      AnimatableElement.endAll( ae );
    }
    else
    {
      await nextFrame(); await nextFrame(); await nextFrame();
  
      AnimatableElement.endAll( ae );
    }

  }


}